import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import DropDown from 'src/components/design-system/DropDown';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const SplitGlCode: FC<GridCellProps> = (props) => {
  const { dataItem, onChange, field = '' } = props;
  const formattedGlCodeOptions = useContextSelector(
    InvoiceContext,
    (value) => value.formattedGlCodeOptions
  );

  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      onChange?.({
        dataIndex: e.target.value.id,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    },
    [dataItem, field, onChange]
  );

  const value = useMemo(() => dataItem[field], [dataItem, field]);

  return (
    <GridCellBase {...props}>
      <DropDown
        onChange={handleChange}
        value={value}
        options={formattedGlCodeOptions}
        valid={!!value}
      />
    </GridCellBase>
  );
};

export default SplitGlCode;
